
export const isEmpty = function(str:any) {
  if (str && str !== undefined && str !== null) {
    return str;
  } else if (str === 0) {
    return "0";
  } else {
    return "";
  }
};
